import { useContext } from 'react';

import { FormikBag } from 'formik';

import { useNavigateToRoute } from '../../../../../../shared/hooks/use-navigate-to-route/use-navigate-to-route.hook';
import { useAppDispatch } from '../../../../../../store/hooks';
import { ReactComponent as CheckmarkIcon } from '../../../../../shared/assets/icons/snackbar-icons/check-mark.svg';
import { ReactComponent as WarningIcon } from '../../../../../shared/assets/icons/snackbar-icons/warning.svg';
import { SnackBarContext } from '../../../../../shared/components/snack-bar-context/SnackBarContext';
import { SnackBarContextModel } from '../../../../../shared/components/snack-bar-context/models/snack-bar-context.model';
import { useSnackbarContextState } from '../../../../../shared/hooks/use-snack-bar-context-state/use-snackbar-context-state.hook';
import { FirmwareRequestModel } from '../../../../models/firmware-request-model';
import { saveFirmware } from '../../../../thunk/save-firmware.thunk';
import { updateFirmware } from '../../../../thunk/update-firmware.thunk';
import { FirmwareDetailsFormModel } from '../../../FirmwareDetailsForm/models/firmware-form.model';
import { OuterFirmwareFormPropsModel } from '../../../FirmwareDetailsForm/models/outer-firmware-form-props.model';

export const useHandleSubmitFirmwareForm = (
  isOnEdit: boolean,
  firmwareId: string | undefined
) => {
  const dispatch = useAppDispatch();
  const snackBarConfig = useSnackbarContextState();
  const snackBarContext = useContext(SnackBarContext) as SnackBarContextModel;
  const navigateFn = useNavigateToRoute('../firmwares');

  const successSnackBarConfig = (actionMessage: string) => {
    snackBarConfig(
      'success',
      `Successfully ${actionMessage} the firmware !`,
      <CheckmarkIcon />
    );
  };

  const errorSnackBarConfig = (actionMessage: string) => {
    snackBarConfig(
      'error',
      `Something went wrong while ${actionMessage} the firmware`,
      <WarningIcon />
    );
  };

  return async (
    values: FirmwareDetailsFormModel,
    formikBag: FormikBag<OuterFirmwareFormPropsModel, FirmwareDetailsFormModel>
  ) => {
    const formObject: FirmwareRequestModel = {
      name: values.name,
      modelId: values.model?.id as number,
      ecuId: values.ecu?.id as number,
      platformId: values.platform?.id as number,
      versionName: values.versionName,
      versionCode: values.versionCode as number,
      description: values.description,
      fileId: formikBag.props.firmwareFileId as number,
      status: values.status?.label as string,
    };

    if (isOnEdit) {
      try {
        await dispatch(
          updateFirmware({
            id: parseInt(firmwareId as string, 10),
            ...formObject,
          })
        ).unwrap();
        successSnackBarConfig('updated');
      } catch {
        errorSnackBarConfig('updating');
      }
    } else {
      try {
        await dispatch(saveFirmware(formObject)).unwrap();
        successSnackBarConfig('added');
        navigateFn();
      } catch {
        errorSnackBarConfig('adding');
      }
    }
    snackBarContext.isOpen(true);
  };
};
